import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Nav, Navbar, NavDropdown, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import _ from 'lodash';
import routes from 'src/navigation/routes';
import { faExclamationTriangle, faBell } from '@fortawesome/free-solid-svg-icons';
import styles from './assets/confirm-notificator.module.scss';
import user from 'src/services/user-auth';
import { StoreState } from '../../../store/reducers';
import { getUnconfirmedSeances } from '../../../store/actions/seance-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QueryParams } from '../../../types/grid';
import { selectGroupUnconfirmed } from 'src/store/selectors/seance-selectors';
import Router from '../../../navigation/router';
import UserRole from '../../../enumerables/user-role';
import logoText from '../../../assets/images/logoText.png';
import logoMobile from '../../../assets/images/logo-m.png';
import { IAgencyInfo } from '../../../types/app';
import GeneralEnum from '../../../enumerables/general-enum';
import LeftMenu from '../LeftMenu/LeftMenu';
import { Paginated } from '../../../services/api-handlers/pagination';
import { IInvoiceDoc } from '../../../types/invoice';
import { getProfile } from '../../../store/actions/auth-actions';

export interface StateProps {
    authorized: boolean;
    authData: any;
}

export interface DispatchProps {
    //getUnconfirmedSeances: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ConfirmNotificator: React.FC<Props> = ({ authorized, authData }: Props) => {
    const location = useLocation();

    const profile = null;
    let userName: string | null = null;
    if (authorized) {
        userName = user.getUsername();
    }
    const [isOpen, setOpen] = useState(false);

    //const isAdmin = securityService.isGranted(UserRole.ROLE_ADMIN, null);
    const isMobile = window.innerWidth <= 800;
    return authorized && authData && authData?.sessionScheduledByNow ? (
        <div>
            <div
                className={classNames(
                    styles.confirmNotificationBox,
                    authData?.sessionConfirmAlert == 'green'
                        ? styles.confirmAll
                        : authData?.sessionConfirmAlert == 'orange'
                        ? styles.confirmPart
                        : styles.confirmNone,
                )}
            >
                ! {authData?.sessionConfirmedInTimeSessionByNow}/{authData?.sessionScheduledByNow} sessions are
                confirmed on time
            </div>
        </div>
    ) : null;
};

export default connect<StateProps, DispatchProps, OwnProps, StoreState>(
    (state) => ({
        authorized: state.auth.authorized,
        authData: state.auth.data,
    }),
    {},
)(ConfirmNotificator);
